module.exports = __webpack_public_path__ + "img/logo.758f83c1.png";